import evidencesDefSlice from './evidencesSlice';

export { default as evidencesOp } from './operations';

export default evidencesDefSlice;
